// Shared group avatar color palette — used everywhere a group needs a consistent color
export const GROUP_AVATAR_COLORS = [
  '#4A7C59', // Green
  '#5B9BD5', // Blue
  '#C27BA0', // Pink
  '#8E7CC3', // Purple
  '#E06666', // Red
  '#6AA84F', // Lime green
  '#45818E', // Teal
  '#F6B26B', // Orange
];

/**
 * Deterministic color for a group based on its name + id.
 * Returns the same hex color for a given group across all views.
 */
export function getGroupAvatarColor(groupName: string, groupId: string): string {
  const str = `${groupName}${groupId}`;
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return GROUP_AVATAR_COLORS[Math.abs(hash) % GROUP_AVATAR_COLORS.length];
}
